import { render, staticRenderFns } from "./PoiMiniCTA.vue?vue&type=template&id=7031bd81&scoped=true&"
import script from "./PoiMiniCTA.vue?vue&type=script&lang=js&"
export * from "./PoiMiniCTA.vue?vue&type=script&lang=js&"
import style0 from "./PoiMiniCTA.vue?vue&type=style&index=0&id=7031bd81&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7031bd81",
  null
  
)

export default component.exports